import React from "react";
import { HStack, Icon, Text, VStack } from "@chakra-ui/react";
import TinyHeading from "components/TinyHeading";

export interface AssetStatProps {
  title: React.ReactNode;
  icon: React.FC;
  value?: number;
  honeyScalar: number;
}

const AssetStat: React.FC<AssetStatProps> = ({
  title,
  icon,
  value,
  honeyScalar,
}) => (
  <VStack align="flex-start" w="50%" bg="dark.400" px={4} py="3.5" gap="0.5">
    <TinyHeading>{title}</TinyHeading>

    <HStack justify="stretch" gap={0.5}>
      <Icon as={icon} w="7" h="auto" color="secondary.500" />
      <Text fontSize="3xl" lineHeight="6">
        {value ?? "–"}
      </Text>
    </HStack>
    <Text fontSize="xs" lineHeight="none">
      <Text as="span" color="secondary.500">
        =
      </Text>{" "}
      <Text as="span" opacity="0.8">
        {((value || 0) * honeyScalar).toFixed()} $HONEY
      </Text>
    </Text>
  </VStack>
);

export default AssetStat;
